import { Controller } from "@hotwired/stimulus";
import { Modal } from 'bootstrap';

export default class extends Controller {

  constructor() {
    super();
    this.modal = new Modal(document.getElementById('folderModal'));
  }

  open(e) {
    this.modal.show();
  }

  submit() {
    document.getElementById('folderSubmitButton').click();
  }
}
